import { render, staticRenderFns } from "./RoundAssets.vue?vue&type=template&id=643aeb09&scoped=true&"
import script from "./RoundAssets.vue?vue&type=script&lang=js&"
export * from "./RoundAssets.vue?vue&type=script&lang=js&"
import style0 from "./RoundAssets.vue?vue&type=style&index=0&id=643aeb09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643aeb09",
  null
  
)

export default component.exports